import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BusinessStore {
  businessData: any | null;
  setBusinessData: (data: any) => void;
  clearBusinessData: () => void;
}

export const useBusinessStore = create<BusinessStore>()(
  persist(
    (set) => ({
      businessData: null,

      setBusinessData: (data) => set({ businessData: data }),
      clearBusinessData: () => set({ businessData: null }),
    }),
    {
      name: 'business-storage',
    }
  )
);
